import { render } from "./singleLayout.vue?vue&type=template&id=3b86eadc&scoped=true"
import script from "./singleLayout.vue?vue&type=script&lang=js"
export * from "./singleLayout.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-3b86eadc"

export default script